import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SalaryScalesFlag } from '../../../../types';

import { ControlledCheckbox } from 'components/shared';
import {
  GridContainer,
  GridCompact6
} from 'components/shared/Grid/Grid.components';

const FlagsSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common');

  return (
    <GridContainer>
      <GridCompact6>
        <ControlledCheckbox
          control={control}
          label={t('salaryScales.grid.flags.BUH_BLOCKED')}
          name={`flags[${SalaryScalesFlag.BUH_BLOCKED}]`}
        />
      </GridCompact6>
      <GridCompact6>
        <ControlledCheckbox
          control={control}
          label={t('salaryScales.grid.flags.BONUS_BLOCKED')}
          name={`flags[${SalaryScalesFlag.BONUS_BLOCKED}]`}
        />
      </GridCompact6>
    </GridContainer>
  );
};

export default FlagsSection;
